











import { Component, Vue, Prop } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import SectionHeader from './SectionHeader.vue';

@Component({
  components: {
    SectionHeader,
  },
})
export default class Section extends Vue {
  @Prop() private title!: string;
  @Prop() private headerStyles!: string;
}
